import LoadingSpinner from './loadingSpinner.svg';

const svgs = {
  loadingSpinner: LoadingSpinner,
} as const;

export type IconName = keyof typeof svgs;

export default svgs;
